import { captchaConstants } from '../constants/actionTypes'

const initialState = {
  isValid: false,
  isValidationInProgress: false
}

export default function applicationRolesReducer(state = initialState, action) {
  switch (action.type) {
    case captchaConstants.VALIDATE_CAPTCHA_SUCCESS:
      return {
        ...state,
        isValid: true,
        isValidationInProgress: false
      }
    case captchaConstants.VALIDATE_CAPTCHA_FAILURE:
        return {
          ...state,
          isValid: false,
          isValidationInProgress: false
        }
    case captchaConstants.VALIDATE_CAPTCHA_INPROGRESS:
            return {
              ...state,
              isValid: false,
              isValidationInProgress: true
            }
    default:
      return state
  }
}
